// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "delete_order-tYR6c";
var _4 = "header-W0kcd";
var _5 = "footer-2hnI6";
var _6 = "content-6lcIW";
export { _1 as "__esModule", _2 as "mobile", _3 as "delete_order", _4 as "header", _5 as "footer", _6 as "content" }
export default { "__esModule": _1, "mobile": _2, "delete_order": _3, "header": _4, "footer": _5, "content": _6 }
